/* global axios */
import ApiClient from '../ApiClient';

class FinancialChartOfAccountsAPI extends ApiClient {
  constructor() {
    super('financeiro/chart_of_accounts', { accountScoped: true });
  }

  getAll() {
    return axios.get(this.url);
  }

  create(data) {
    return axios.post(this.url, { financial_chart_of_account: data });
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, {
      financial_chart_of_account: data,
    });
  }

  destroy(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new FinancialChartOfAccountsAPI();
